import React, { useEffect, useState } from "react";
import { MovePersonButton, PartnerCardsButton } from "@/components/nds/MovePerson";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";
import { Btn, Pill, when } from "./kit";
import { PartnerEditDialog } from "./PartnerEditDialog";
import { LoginPinButton, PinStatus, useLoginPinRefresh } from "./LoginPin";
import { PreviewAsButton, LoginAsButton } from "./PreviewAs";

export const PartnersTab = ({ meta }) => {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => apiClient.get("/console/partners").then(({ data }) => setRows(data.partners)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);
  useLoginPinRefresh(load);
  return (
    <div className="space-y-4" data-testid="console-partners-tab">
      <p className="text-sm text-white/60">{rows.length} partner portal accounts · new partners are added from the Partner Engine</p>
      <div className="overflow-x-auto border border-white/10 rounded-sm">
        <table className="w-full text-sm">
          <thead><tr className="text-left border-b border-white/10 font-mono text-[10px] tracking-[0.18em] uppercase text-white/50">
            <th className="p-3">Partner</th><th className="p-3">Type</th><th className="p-3">Status</th><th className="p-3">Last login</th><th className="p-3">PIN</th><th className="p-3" />
          </tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} data-testid={`partner-row-${p.id}`} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                <td className="p-3"><div className="text-white">{p.first_name} {p.last_name}</div>
                  <div className="text-[11px] text-white/50 font-mono">{p.email}{p.organization ? ` · ${p.organization}` : ""}</div></td>
                <td className="p-3 font-mono text-[11px] text-white/70">{p.type.replace(/_/g, " ")}</td>
                <td className="p-3"><Pill v={p.status} testId={`partner-status-${p.id}`} /></td>
                <td className="p-3 text-[11px] text-white/50">{when(p.last_login_at)}</td>
                <td className="p-3 text-[11px]"><PinStatus row={p} testId={`partner-pin-${p.id}`} /></td>
                <td className="p-3 text-right"><div className="flex flex-wrap justify-end gap-y-1 max-w-[520px] ml-auto"><LoginPinButton kind="partner" id={p.id} name={`${p.first_name} ${p.last_name}`} login={p.email} source="console_users_partner" className="mr-2" /><PreviewAsButton kind="partner" id={p.id} name={`${p.first_name} ${p.last_name}`} className="mr-2" /><LoginAsButton kind="partner" id={p.id} name={`${p.first_name} ${p.last_name}`} className="mr-2" /><PartnerCardsButton partner={p} onDone={load} /><MovePersonButton kind="partner" id={p.id} onDone={load} className="mr-2" /><Btn tone="muted" className="mr-2" data-testid={`partner-edit-${p.id}`} onClick={() => setEdit(p.id)}><Pencil size={12} /> Edit</Btn></div></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="p-6 text-center text-white/40">No partner accounts yet</td></tr>}
          </tbody>
        </table>
      </div>
      {edit && <PartnerEditDialog partnerId={edit} meta={meta} onClose={() => setEdit(null)} onSaved={load} />}
    </div>
  );
};
